<template>
    <div class="container mt-2 pt-5">
        <h1 class="mb-4">{{ t('Imprint') }}</h1>
        <h5>Hägele GmbH</h5>
        <address class="mb-4">
            Am Niederfeld 13<br>
            73614 Schorndorf, Germany<br>
        </address>
        <p>
            Telefon: +49 7181 96988-0<br>
            Telefax: +49 7181 96988-80<br>
            E-Mail: <a href="mailto:info@cleanfix.org">info@cleanfix.org</a>
        </p>
        <p class="text-muted">
            Handelsregister: HRB 280915<br>
            Registergericht: Amtsgericht Stuttgart
        </p>
        <p class="text-muted">
            Vertreten durch:<br>
            Benjamin Hägele
        </p>
        <p class="text-muted">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br>
            DE 146 625 401
        </p>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>

</style>
